import { Input, KeyCode } from "../../lib/Input";
import SPAbility from "../SPAbility";
import SPPlayer from "../SPPlayer";

export default class Hypercharge extends SPAbility {
    constructor(player: SPPlayer) {
        super(player, {
            cooldown: 20,
            duration: 5,
            icon: 3,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown
        });
    }

    onDurationEnd(): void {
        this.player.gun.damage -= 3;
    }

    onUse(): void {
        this.player.gun.damage += 3;
    }
}